module.exports = __webpack_public_path__ + "static/media/Floor.cb833901.png";